import { toggle } from '@/store/basket';
import { Badge, Menu, Popover } from 'antd';
import React from 'react'
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useWindowDimensions } from '@/hooks/useWindowDimensions';
import useCalculateTotalBasket from '@/hooks/useCalculateTotalBasket'
import useCurrencyWithCode from '@/hooks/useCurrencyWithCode'
import { useNavigate } from 'react-router-dom';
import fetchAccount from "@/core/account/fetchAccount";

const AccountMenu = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const isAdmin = (useSelector((e) => e?.session?.account?.Role) == 1) ? true : false

  return (
    <div>
      <Menu mode="inline" >
        <Menu.Item onClick={(e) => navigate('/account/profile')} key="account/profile">{t('profile')}</Menu.Item>
        <Menu.Item onClick={(e) => navigate('/logout')} key="logout">{t('logout')}</Menu.Item>
        {isAdmin && <Menu.Item onClick={(e) => navigate('/management/users')} key="management">{t('management')}</Menu.Item>}
      </Menu>
    </div>
  );
};

const LogoMap = ({ Color = "white" }) => (
  <svg width={27} height={21} viewBox="0 0 27 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.39039 11.5316L0.42342 19.6809C0.262102 20.0123 0.431671 20.2835 0.800278 20.2835H25.6881C26.0567 20.2835 26.2263 20.0123 26.0649 19.6809L22.0979 11.5316C22.0348 11.402 21.8652 11.2959 21.721 11.2959H18.3195C18.2147 11.2959 18.0731 11.3615 18.0045 11.4408C17.7737 11.7075 17.5387 11.968 17.3043 12.2259C17.0817 12.4707 16.8579 12.7187 16.6358 12.9725H20.6726C20.8168 12.9725 20.9864 13.0786 21.0495 13.2082L23.6774 18.6069H2.81102L5.43878 13.2082C5.50184 13.0786 5.67145 12.9725 5.81568 12.9725H9.86157C9.63959 12.7187 9.41572 12.4707 9.19311 12.2259C8.95799 11.9673 8.72162 11.7072 8.49029 11.4405C8.42176 11.3614 8.28048 11.2959 8.17583 11.2959H4.76716C4.62306 11.2959 4.45349 11.4019 4.39039 11.5316ZM7.41193 5.96247C7.41193 10.4154 11.1189 11.2505 12.8624 15.5297C13.004 15.8775 13.4936 15.8757 13.6353 15.528C15.208 11.6698 18.377 10.6117 18.9834 7.17458C19.5804 3.79083 17.2375 0.476247 13.8168 0.152897C10.3379 -0.175968 7.41193 2.55157 7.41193 5.96247ZM10.1662 5.96247C10.1662 4.26022 11.5461 2.88026 13.2484 2.88026C14.9507 2.88026 16.3306 4.26022 16.3306 5.96247C16.3306 7.66476 14.9507 9.04467 13.2484 9.04467C11.5461 9.04467 10.1662 7.66476 10.1662 5.96247Z"
      fill={Color}
    />
  </svg>
);

const LogoPhone = ({ Color = "white" }) => (
  <svg width={21} height={21} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.9923 3.31802L17.3091 0.637409C16.9816 0.309891 16.5432 0.125977 16.0797 0.125977C15.6161 0.125977 15.1777 0.307371 14.8502 0.637409L11.9605 3.52209C11.633 3.84961 11.4491 4.2905 11.4491 4.75406C11.4491 5.22014 11.6305 5.65599 11.9605 5.98603L14.2179 8.24591C13.7036 9.44408 12.9647 10.5327 12.0411 11.4531C11.1165 12.3827 10.0357 13.1158 8.83648 13.6348L6.57913 11.375C6.25161 11.0474 5.81324 10.8635 5.34967 10.8635C5.12102 10.8627 4.89451 10.9075 4.68339 10.9953C4.47228 11.0831 4.28081 11.2122 4.12022 11.375L1.22798 14.2596C0.900467 14.5872 0.716553 15.0281 0.716553 15.4916C0.716553 15.9577 0.897947 16.3935 1.22798 16.7236L3.90859 19.4042C4.46789 19.9635 5.23882 20.2835 6.0299 20.2835C6.19366 20.2835 6.35238 20.2709 6.51362 20.2431C9.84927 19.6939 13.1597 17.9178 15.8328 15.2472C18.5033 12.5717 20.2769 9.26121 20.8312 5.92305C20.9899 4.97576 20.6725 4.00077 19.9923 3.31802ZM19.045 5.62324C18.5537 8.59358 16.9564 11.5564 14.5504 13.9624C12.1444 16.3684 9.18416 17.9656 6.21382 18.4569C5.84095 18.5199 5.45801 18.3939 5.18591 18.1244L2.55317 15.4916L5.34464 12.6976L8.36284 15.7209L8.38552 15.7436L8.9297 15.542C10.5797 14.9354 12.0781 13.9772 13.3209 12.7339C14.5638 11.4906 15.5215 9.99186 16.1275 8.34164L16.3291 7.79746L13.2857 4.75658L16.0772 1.9626L18.7099 4.59534C18.982 4.86743 19.108 5.25038 19.045 5.62324Z"
      fill={Color}
    />
  </svg>
);

const CurrencyIcon = ({ Color = "white" }) => (
  <svg width={23} height={23} viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.3381 10.2976C10.5441 9.70299 9.67733 9.33007 9.67733 8.38267C9.67733 7.35464 10.7961 6.98173 11.5016 6.98173C12.8219 6.98173 13.3057 7.97952 13.4165 8.33228L15.009 7.657C14.8578 7.20346 14.1825 5.72188 12.449 5.39936V4.1496H10.4332V5.41952C7.9337 5.98393 7.92363 8.30204 7.92363 8.40283C7.92363 10.6907 10.1913 11.3357 11.3 11.7389C12.8924 12.3033 13.598 12.8173 13.598 13.7849C13.598 14.9238 12.5397 15.4076 11.6024 15.4076C9.76803 15.4076 9.24394 13.5228 9.18347 13.3011L7.5104 13.9764C8.14536 16.1836 9.80835 16.7783 10.4332 16.9597V18.2598H12.449V17.0101C12.8521 16.9194 15.3718 16.4154 15.3718 13.7647C15.3718 12.3638 14.757 11.1342 12.3381 10.2976ZM2.37024 20.2756H0.354492V14.2283H6.40174V16.2441H3.90221C5.52489 18.6731 8.29654 20.2756 11.4411 20.2756C13.8468 20.2756 16.1541 19.3199 17.8552 17.6188C19.5563 15.9177 20.512 13.6105 20.512 11.2047H22.5277C22.5277 17.3326 17.569 22.2913 11.4411 22.2913C7.69181 22.2913 4.37591 20.4268 2.37024 17.5846V20.2756ZM0.354492 11.2047C0.354492 5.07684 5.31323 0.118103 11.4411 0.118103C15.1904 0.118103 18.5063 1.98267 20.512 4.82487V2.13385H22.5277V8.1811H16.4805V6.16535H18.98C17.3573 3.73637 14.5857 2.13385 11.4411 2.13385C9.03536 2.13385 6.72815 3.08953 5.02704 4.79065C3.32592 6.49176 2.37024 8.79897 2.37024 11.2047H0.354492Z"
      fill={Color}
    />
  </svg>
);

const WorldIcon = ({ Color = "white" }) => (
  <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.23633 11.2047C1.23633 16.771 5.74873 21.2835 11.3151 21.2835C16.8814 21.2835 21.3938 16.771 21.3938 11.2047C21.3938 5.63838 16.8814 1.12598 11.3151 1.12598C5.74873 1.12598 1.23633 5.63838 1.23633 11.2047Z"
      stroke={Color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12.323 1.17566C12.323 1.17566 15.3466 5.15739 15.3466 11.2046C15.3466 17.2518 12.323 21.2336 12.323 21.2336" stroke={Color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.3073 21.2336C10.3073 21.2336 7.28369 17.2518 7.28369 11.2046C7.28369 5.15739 10.3073 1.17566 10.3073 1.17566" stroke={Color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1.87109 14.7323H20.7594" stroke={Color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1.87109 7.67719H20.7594" stroke={Color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const HistoryIcon = ({ Color, Width = 45, Height = 47 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={27}
    viewBox="0 0 30 27"
    fill="none"
  >
    <g clipPath="url(#clip0_80_275)">
      <line
        x1={14.2035}
        y1={8.17331}
        x2={14.2035}
        y2={16.6133}
        stroke={Color}
        strokeWidth={1.56}
        strokeLinecap="round"
      />
      <line
        x1={14.2035}
        y1={16.6133}
        x2={17.6435}
        y2={16.6133}
        stroke={Color}
        strokeWidth={1.56}
        strokeLinecap="round"
      />
      <path
        d="M23.4372 21.8865C21.7884 23.4405 19.7158 24.4707 17.4816 24.8468C15.2473 25.2229 12.9517 24.9279 10.885 23.9993C8.81831 23.0707 7.07341 21.5501 5.87094 19.6299C4.66847 17.7096 4.06243 15.4758 4.12947 13.2111C4.19651 10.9464 4.93361 8.75241 6.24756 6.90661C7.56151 5.06081 9.3933 3.64609 11.5113 2.84136C13.6293 2.03662 15.9383 1.87801 18.1464 2.38559C20.3546 2.89316 22.3626 4.04412 23.9166 5.69292"
        stroke={Color}
        strokeWidth={1.56}
        strokeLinecap="round"
      />
      <path
        d="M24.5801 3.55005L24.5801 6.55005"
        stroke={Color}
        strokeWidth={1.56}
        strokeLinecap="round"
      />
      <path
        d="M21.5801 6.55005L24.5801 6.55005"
        stroke={Color}
        strokeWidth={1.56}
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_80_275">
        <rect
          width={29}
          height={26}
          fill="white"
          transform="translate(0.959961 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

const BasketIcon = ({ Color, Width = 35, Height = 40 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={27}
    viewBox="0 0 33 27"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.959961 1.56155C0.959961 1.08555 1.34556 0.699951 1.82156 0.699951H5.65356C6.83356 0.699951 7.86396 1.49995 8.15756 2.64235L11.8008 16.8528C11.8984 17.2336 12.2424 17.5 12.6352 17.5H26.8704C27.2376 17.5 27.5648 17.2672 27.6848 16.9192L30.804 7.87275C30.8487 7.74299 30.8618 7.60442 30.8421 7.46859C30.8225 7.33275 30.7707 7.20357 30.691 7.09181C30.6113 6.98005 30.5061 6.88894 30.3841 6.82606C30.2621 6.76319 30.1268 6.73038 29.9896 6.73035H14.744C14.6287 6.73387 14.5138 6.71419 14.4063 6.67249C14.2987 6.6308 14.2006 6.56792 14.1178 6.48761C14.035 6.40729 13.9692 6.31116 13.9242 6.20493C13.8793 6.09869 13.8561 5.98451 13.8561 5.86915C13.8561 5.7538 13.8793 5.63961 13.9242 5.53338C13.9692 5.42714 14.035 5.33101 14.1178 5.2507C14.2006 5.17038 14.2987 5.10751 14.4063 5.06581C14.5138 5.02411 14.6287 5.00444 14.744 5.00795H29.9888C31.764 5.00795 33.0104 6.75675 32.432 8.43515L29.312 17.4808C29.1368 17.9892 28.8074 18.4304 28.3695 18.7427C27.9317 19.0551 27.4074 19.223 26.8696 19.2232H12.6352C12.0614 19.2234 11.5038 19.0326 11.0504 18.6809C10.5971 18.3292 10.2736 17.8366 10.1312 17.2808L6.48796 3.06955C6.44054 2.88424 6.3328 2.71998 6.18173 2.60266C6.03066 2.48534 5.84484 2.42162 5.65356 2.42155H1.82156C1.59347 2.42155 1.37468 2.33111 1.21316 2.17004C1.05165 2.00898 0.960596 1.78965 0.959961 1.56155ZM13.76 26.2992C14.0869 26.305 14.4117 26.2457 14.7155 26.1247C15.0193 26.0037 15.2959 25.8233 15.5292 25.5942C15.7625 25.3651 15.9478 25.0917 16.0743 24.7902C16.2008 24.4887 16.2659 24.1649 16.2659 23.838C16.2659 23.511 16.2008 23.1872 16.0743 22.8857C15.9478 22.5842 15.7625 22.3108 15.5292 22.0817C15.2959 21.8526 15.0193 21.6722 14.7155 21.5512C14.4117 21.4302 14.0869 21.3709 13.76 21.3768C13.1071 21.3768 12.481 21.6361 12.0193 22.0977C11.5577 22.5594 11.2984 23.1855 11.2984 23.8384C11.2984 24.4912 11.5577 25.1173 12.0193 25.579C12.481 26.0406 13.1071 26.2992 13.76 26.2992ZM28.2832 23.8384C28.2832 24.4912 28.0238 25.1173 27.5622 25.579C27.1005 26.0406 26.4744 26.3 25.8216 26.3C25.1687 26.3 24.5426 26.0406 24.0809 25.579C23.6193 25.1173 23.36 24.4912 23.36 23.8384C23.36 23.1855 23.6193 22.5594 24.0809 22.0977C24.5426 21.6361 25.1687 21.3768 25.8216 21.3768C26.4744 21.3768 27.1005 21.6361 27.5622 22.0977C28.0238 22.5594 28.2832 23.1855 28.2832 23.8384Z"
      fill={Color}
    />
  </svg>
);

const AccountIcon = ({ Color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={27}
    viewBox="0 0 30 27"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.48711 8.69855C8.48711 7.87585 8.64915 7.0612 8.96398 6.30113C9.27882 5.54105 9.74028 4.85042 10.322 4.26868C10.9038 3.68694 11.5944 3.22548 12.3545 2.91065C13.1145 2.59581 13.9292 2.43377 14.7519 2.43377C15.5746 2.43377 16.3892 2.59581 17.1493 2.91065C17.9094 3.22548 18.6 3.68694 19.1818 4.26868C19.7635 4.85042 20.225 5.54105 20.5398 6.30113C20.8546 7.0612 21.0167 7.87585 21.0167 8.69855C21.0167 10.3601 20.3566 11.9536 19.1818 13.1284C18.0069 14.3033 16.4134 14.9633 14.7519 14.9633C13.0904 14.9633 11.4969 14.3033 10.322 13.1284C9.14714 11.9536 8.48711 10.3601 8.48711 8.69855ZM14.7519 0.959473C10.4779 0.959473 7.01281 4.4238 7.01281 8.69855C7.01281 12.9725 10.4771 16.4369 14.7519 16.4369C19.0259 16.4369 22.4902 12.9725 22.4902 8.69855C22.4902 4.4238 19.0251 0.959473 14.7519 0.959473ZM14.7284 20.8597C19.5349 20.8537 24.1748 22.6202 27.7603 25.8211C27.8321 25.8877 27.9165 25.9394 28.0085 25.973C28.1005 26.0066 28.1982 26.0216 28.296 26.017C28.3939 26.0124 28.4898 25.9883 28.5782 25.9462C28.6667 25.9041 28.7458 25.8448 28.811 25.7718C28.8763 25.6987 28.9263 25.6134 28.9582 25.5208C28.99 25.4282 29.0031 25.3302 28.9967 25.2324C28.9902 25.1347 28.9643 25.0393 28.9205 24.9517C28.8767 24.8641 28.8159 24.7861 28.7416 24.7222C24.8858 21.2794 19.8959 19.3793 14.7268 19.3853C9.55764 19.3914 4.57223 21.3033 0.724512 24.7551C0.652463 24.8198 0.59385 24.898 0.552021 24.9853C0.510192 25.0726 0.485966 25.1672 0.480726 25.2639C0.475486 25.3605 0.489334 25.4573 0.52148 25.5486C0.553626 25.6399 0.603441 25.724 0.66808 25.796C0.732718 25.8681 0.810915 25.9267 0.898206 25.9685C0.985497 26.0103 1.08017 26.0346 1.17682 26.0398C1.27348 26.045 1.37022 26.0312 1.46152 25.999C1.55282 25.9669 1.63689 25.9171 1.70894 25.8524C5.28685 22.6428 9.92183 20.8652 14.7284 20.8597Z"
      fill={Color}
    />
  </svg>
);



const HeaderIcons = ({ showHistory = true, showBasket = true, showAccount = true }) => {
  const d = useDispatch();
  const navigate = useNavigate()
  const settings = useSelector(e => e.settings)
  const { t } = useTranslation()
  const basket = useSelector(e => e.basket)
  const basketList = basket['basketList']

  const total = useCalculateTotalBasket()
  const currencyWithCode = useCurrencyWithCode()

  const { width } = useWindowDimensions();
  const isMobile = width > 1024 ? false : true;

  const [accountInfo, setAccountInfo] = useState({})
  const _hideNetPrice = useSelector((e => e.settings['hideNetPrice']))
  const hideNetPrice = _hideNetPrice == 'true' || _hideNetPrice == true ? true : false

  useEffect(() => {
    fetchAccount().then((res) => {
      let data = res.data.data;
      setAccountInfo(data)
    }).catch(e => {
      console.log("Profile not fetching !")
    }).finally()
  }, [])

  return (
    <>
      {showHistory ? <div onClick={() => navigate('/history')} className=" header3__bottom__container__right-menu__item" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row' }}>
        <HistoryIcon Color={settings['HeaderBaseIconColor']} />
        <span style={{
          fontSize: '13px',
          paddingLeft: '10px',
          color: settings['HeaderBaseTextColor']
        }}>{t('history')}</span>
      </div> : null}

      {showBasket ? <div onClick={() => d(toggle(true))} className=" header3__bottom__container__right-menu__item" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row' }}>
        <Badge count={typeof basketList == 'object' ? basketList.length : null}>
          <BasketIcon Color={settings['HeaderBaseIconColor']} />
        </Badge>
        <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
          <span style={{
            fontSize: '13px',
            paddingLeft: '10px',
            color: settings['HeaderBaseTextColor'] + '95'
          }}>{t('basket')}</span>
          <span style={{
            fontSize: '13px',
            paddingLeft: '10px',
            color: settings['HeaderBaseTextColor'],
            lineHeight: '22px',
            fontWeight: '500'
          }}>
            {
              
              hideNetPrice ? currencyWithCode(total.GrossPrice) : currencyWithCode(total.NetPrice)

            }
          </span>
        </div>

      </div> : null}
      {showAccount ? <div className=" header3__bottom__container__right-menu__item ">
        <Popover placement="bottom" content={<AccountMenu />} trigger="click">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row' }}>
            <AccountIcon Color={settings['HeaderBaseIconColor']} />
            <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
              <span style={{
                fontSize: '13px',
                paddingLeft: '10px',
                color: settings['HeaderBaseTextColor'] + '95',
              }}>{t('account')}</span>
              <span style={{
                fontSize: '13px',
                paddingLeft: '10px',
                lineHeight: '22px',
                color: settings['HeaderBaseTextColor'],
                fontWeight: '500'
              }}>Hi,{accountInfo?.['FirstName'] || ""}</span>
            </div>
          </div>
        </Popover>
      </div> : null}</>
  )
}

export default HeaderIcons
